import React, { Component } from 'react';
import PropTypes from "prop-types"

import Header from './Header';
import Footer from './Footer';

import "../styles/main.scss"

const Layout = ({ children }) => (
        <div>
        <Header />
        <div className="container">
        {children()}
        </div>
        <Footer />
        </div>
)

Layout.propTypes = {
  children: PropTypes.any,
}

export default Layout


// WEBPACK FOOTER //
// ./src/layouts/index.js